module.exports = __webpack_public_path__ + "static/media/autochilango-off-app-provider-icon.a3de4459.svg";